module.exports = __webpack_public_path__ + "img/img104.c9aa2577.svg";